angular.module("razor_views")

    .controller('RazorViewsListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$stateParams', '$state',
        function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $stateParams, $state) {

        $rootScope.title = $filter('translate')('razor_views.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('razor_views.title') }
        ];

        $scope.gridOptionsRazorViews = {
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [20, 50, 100],
            paginationPageSize: 100,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'name', displayName: $filter('translate')('razor_views.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'path', displayName: $filter('translate')('razor_views.path'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('razor_views.button_edit'), action: 'ui-sref="razor_views.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" }
                    ], { cssClass: "pull-right" })
                },

            ],
            getData: function (options) {
                return Restangular.all('RazorViews').getList();
            }

        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("razor_views.edit", { id: rowEntity.id });
        }

        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('razor_views.button_delete'),
                message: $filter('translate')('razor_views.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('RazorViews', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('razor_views.success'));
                        $scope.gridOptionsRazorViews.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
        $scope.reloadViews = function () {
            Restangular.all('RazorViews/Reload').customPUT({}).then(function () {});
        };
        
    }]);
